/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useContent } from '../../context/ContentContext';
import './About.css'

const About = () => {
  const { content, aboutImages } = useContent();
  const [dynamicAboutImg2, setDynamicAboutImg2] = useState('');
  

  useEffect(() => {
    if (aboutImages && aboutImages.img2) {
      setDynamicAboutImg2(aboutImages.img2);
    } else {
      setDynamicAboutImg2('/assets/img/newlogo.PNG');
    }
  }, [aboutImages]);

  const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }

  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  
  return imageUrl;
};

  return (
    <section className="about section" id="about">
      <div className="about__container container grid">
        <div className="about__data">
          <span className="section__subtitle">ABOUT US</span>
          <h2 className="section__title">
            {content.about?.title} <br />
          </h2>

          <p className="about__description">
            {content.about?.description}
          </p>
        

          <h3 className="about__services-title">Our Core Values</h3>

          <ul className="about__list grid">
            {content.about?.services?.map((service, index) => (
              <li key={index} className="about__list-item">
                <i className="ri-checkbox-circle-line"></i>
                <span>{service}</span>
              </li>
            ))}
          </ul>

        </div>

        <div className="about__images">
          <img src={getImageUrl(dynamicAboutImg2)} alt="team" className="about__img-2" />
        </div>
      </div>
    </section>
  );
};

export default About;